import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible/flexible";

import MintUI from "mint-ui";
import "mint-ui/lib/style.css";
Vue.use(MintUI);

import Vant from "vant";
import "vant/lib/index.css";

Vue.use(Vant);

// Vue.use(VueGlobal);
// import VueLazyload from "vue-lazyload";
// Vue.use(VueLazyload);
// Vue.config.productionTip = false;

import "./assets/common/common.scss";
import "../theme/index.css";

import animated from "animate.css"; // npm install animate.css --save安装，在引入
Vue.use(animated);

//轮播图
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper, /* { default global options } */)

//导入element-ui
import ElementUI from "element-ui";
import "./assets/common/reset.css";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import tcLocale from "element-ui/lib/locale/lang/zh-TW";
const cn = require("./assets/i18n/lang/simple.json");
const tc = require("./assets/i18n/lang/tradition.json");
const en = require("./assets/i18n/lang/english.json");
import ElementLocale from "element-ui/lib/locale";
import VueI18n from "vue-i18n";
Vue.use(VueI18n); // 通过插件的形式挂载

const i18n = new VueI18n({
  locale: "tc", // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    cn: { ...cn, ...zhLocale }, // 简体
    tc: { ...tc, ...tcLocale }, // 繁体
    en: { ...en, ...enLocale } // 英文
  }
});

ElementLocale.i18n((key, value) => i18n.t(key, value));
// import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

//跳转的旧官网页面
// if (process.env.NODE_ENV === "local") {
//   Vue.prototype.oldLink = "http://172.20.18.174:8062/";
// } else {
  Vue.prototype.oldLink = window.location.origin + "/";
// }

//终端号配置
// Vue.prototype.terminal_no = "36226812";
// Vue.prototype.terminal_no =
//   process.env.NODE_ENV == "production"
//     ? "36226812"
//     : process.env.NODE_ENV == "test"
//     ? "36184809"
//     : "36206980";

let utils = require("./utils/fun");
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "选购产品-全球付";
  if (to.path == "/auth") {
    if (utils.isMobile()) {
      if (to.query.order_no) {
        let order_no = to.query.order_no;
        next({ name: "auth-app", params: { order_no } });
      } else {
        next({ name: "auth-app" });
      }
    } else {
      next();
    }
  } else if (to.path === "/inquire-app") {
    next();
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
